import type { IconNode } from '../types';

/**
 * @name planet
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI4IiAvPgogIDxwYXRoIGQ9Ik00LjA1IDEzYy0xLjcgMS44LTIuNSAzLjUtMS44IDQuNSAxLjEgMS45IDYuNCAxIDExLjgtMnM4LjktNy4xIDcuNy05Yy0uNi0xLTIuNC0xLjItNC43LS43IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/planet
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const planet: IconNode = [
  ['circle', { cx: '12', cy: '12', r: '8', key: '46899m' }],
  [
    'path',
    {
      d: 'M4.05 13c-1.7 1.8-2.5 3.5-1.8 4.5 1.1 1.9 6.4 1 11.8-2s8.9-7.1 7.7-9c-.6-1-2.4-1.2-4.7-.7',
      key: '1cniyf',
    },
  ],
];

export default planet;
